import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Image, Col, Row, Button } from "react-bootstrap";
import Loader from "../Loader/Loader";
// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";

// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

import FroalaEditor from "react-froala-wysiwyg";
import { MdKeyboardArrowLeft } from "react-icons/md";
import TabsSection from "../../Components/Tabs/TabsSection";
import SideBar from "../SideBar/SideBar";
import swal from "sweetalert";
import { CreateTemplateApi } from "../API/Communications/CreateTemplate";
import { getToken } from "../../Utils/LocalStorage";
import { FroalaTextEditor } from "../FroalaEditor/FroalaTextEditor";
import { FroalaDefault } from "../../Utils/FroalaDefaultText";
import BackButton from "../BackButton/BackButton";

export const CreateTemplate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // create
  const [TemplateName, setTemplateName] = useState("");
  const [email, setEmail] = useState("");
  // err
  const [TemplateNameErr, setTemplateNameErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);

  //  add-image
  const [image, setImage] = useState(null);
  const inputRef = useRef();
  const [TemplateContent, setTemplateContent] = useState(FroalaDefault.text);

  //    save-api
  const SaveHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(TemplateName, email, "dataa");
    if (TemplateName.length == 0) {
      setTemplateNameErr(true);
      setLoading(false);
    }
    if (email.length == 0) {
      setEmailErr(true);
      setLoading(false);
    }
    if (TemplateName.length && email.length != 0) {
      setLoading(true);
      const cityId = localStorage.getItem("cityId");
      const data = {
        user_id: parseInt(cityId),
        template_name: TemplateName,
        email_subject: email,
        template_content: TemplateContent,
        template_img: image,
      };
      const Response = await CreateTemplateApi(data, () => {
        navigate("/");
      });
      setLoading(false);
      if (Response.status === 429) {
        swal({
          text: `${Response.message}`,
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        });
        setLoading(true);
      }
      if (Response.success == false) {
        swal({
          text: `${Response.message}`,
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        });
        swal.stopLoading();
        swal.close();
      } else {
        swal({
          // title: "Success!",
          title: `${Response.message}`,
          icon: "success",
          buttons: "Ok",
          dangerMode: false,
        });
        setTimeout(() => {
          swal.stopLoading();
          swal.close();
          navigate("/communications/manage-templates");
        }, 2000);
      }
    }
  };
  // cancel
  const CancelHandler = (e) => {
    setTemplateNameErr(false);
    setEmailErr(false);
    navigate("/communications/manage-templates");
  };
  //  onchange
  const handleFormData = (feild, e) => {
    if (feild === "TemplateName") {
      setTemplateName(e.target.value);
      if (e.target.value.length != 0) {
        setTemplateNameErr(false);
      } else {
        setTemplateNameErr(true);
      }
    }

    if (feild === "email") {
      setEmail(e.target.value);
      if (e.target.value.length != 0) {
        setEmailErr(false);
      } else {
        setEmailErr(true);
      }
    }
  };

  // img
  const triggerFileSelectPopup = (e) => {
    e.preventDefault();
    inputRef.current.click();
  };

  // Image Upload froala

  // Handle image uploads
  const handleImageUpload = (e, editor, response) => {
    const imgSrc = response.link;

    // Insert the uploaded image into the editor
    editor.image.insert(imgSrc, false, null, editor.image.get(), null);

    // Update the editor content
    setTemplateContent(editor.html.get());
  };

  //

  const onSelectFile = (event) => {
    // console.log(event.target.files[0].type, "event.target.files");
    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader();
      console.log(reader, "reader", event.target.files[0]);
      reader.readAsDataURL(event.target.files[0]);
      setImage(event.target.files[0]);
      reader.addEventListener("load", () => {
        setImage(reader.result);

        // const contentType = 'image/png';
        // const byteCharacters = atob(b64Data);
        // const byteNumbers = new Array(byteCharacters.length);
        // for (let i = 0; i < byteCharacters.length; i++) {
        //     byteNumbers[i] = byteCharacters.charCodeAt(i);
        // }
        // const byteArray = new Uint8Array(byteNumbers);
        // const blob = new Blob([byteArray], {type: contentType});
        // let typeImg = event.target.files[0].type;
        // console.log(typeImg, "typeImg" , blob);
        //  setimageType(typeImg[1]);
        // setbannerupdate(true)
      });
    }
  };
  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Communications</p>
          <div className="acc-dashboard mt-4">
            <TabsSection />

            {/* start */}
            <div className="manage-vou-main pt-3 pb-3">
              <div>
                <p className="page-maintitle pt-2">Create Template</p>
              </div>
            </div>
            <Row>
              <Col md="2"></Col>
              <Col md="8">
                <Form
                  // onSubmit={SaveHandler}
                  className="formmain mx-0 mt-4 signin-row profile-form pb-4"
                >
                  <Row>
                    <Col md="6" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Template Name <span className="star-required">*</span>
                        </Form.Label>

                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={TemplateName}
                            placeholder="Enter Template Name"
                            className="custom-formcontrol"
                            onChange={(e) => handleFormData("TemplateName", e)}
                            // maxLength={20}
                            autoComplete="off"
                          />
                        </InputGroup>
                        {TemplateNameErr && (
                          <p style={{ color: "red" }}>
                            *Please enter template name!
                          </p>
                        )}
                        {/* <ErrorLabel ErrorDisplay={errDisplayFirstName} /> */}
                        {/* // */}
                      </Form.Group>
                    </Col>
                    <Col md="6" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Email Subject <span className="star-required">*</span>
                        </Form.Label>
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            value={email}
                            placeholder="Enter Email Subject"
                            // maxLength={20}
                            className="custom-formcontrol"
                            onChange={(e) => handleFormData("email", e)}
                            autoComplete="off"
                          />
                        </InputGroup>
                        {emailErr && (
                          <p style={{ color: "red" }}>
                            *Please enter valid email subject!
                          </p>
                        )}
                        {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
                      </Form.Group>
                    </Col>
                    <Col md="12" className="">
                      <Form.Group
                        className="mb-4 mt-4"
                        controlId="formBasicEmail"
                      >
                        <Form.Label className="form-label-custom flex-content">
                          Template Content{" "}
                          <span className="star-required">*</span>
                          <p className="info-text-space-f-13">
                            &#40;To start from a new line, please press Shift +
                            Enter.&#41;
                          </p>
                        </Form.Label>
                        <div className="p-3 page_cont">
                          {/* <div
                            style={{
                              marginBottom: 20,
                            }}
                          >
                            <div className="page_img">
                              {image == null ? (
                                <div>
                                  {" "}
                                  <img src={AddImage} />
                                  <p className="size_p">1500 X 450 Px</p>{" "}
                                  <button
                                    className="check-green-btn2 btn btn-primary"
                                    onClick={(e) => triggerFileSelectPopup(e)}
                                  >
                                    + Add Picture
                                  </button>
                                </div>
                              ) : (
                                <div>
                                  {" "}
                                  <img
                                    src={image}
                                    className="imageUpload"
                                    onClick={(e) => triggerFileSelectPopup(e)}
                                  />
                                </div>
                              )}

                              <input
                                type="file"
                                accept="image/*"
                                ref={inputRef}
                                onChange={onSelectFile}
                                style={{ display: "none" }}
                              />
                            </div>
                          </div> */}
                          <FroalaTextEditor
                            TemplateContent={TemplateContent}
                            setTemplateContent={setTemplateContent}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="text-center small-btns d-flex option_btn">
                    <Button
                      className="discard_btn"
                      onClick={(e) => CancelHandler(e)}
                      style={{ minWidth: "100px" }}
                    >
                      Discard
                    </Button>
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3"
                      onClick={(e) => SaveHandler(e)}
                      style={{ minWidth: "100px" }}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              </Col>
              <Col md="2"></Col>
            </Row>

            {/* end */}
          </div>
        </div>
      </div>
    </>
  );
};
